import "./svg/meny-mer-logo-full-color.svg"

export default {
    name: "meny-mer-logo-full-color",
    viewBox: "539 366",
}
